module.exports = __webpack_public_path__ + "img/item-02.c0dd658f.png";